import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { Baseservice } from "./baseservice";
import * as signalR from "@microsoft/signalr";
import { environment } from "environments/environment";
import { BehaviorSubject, empty, interval, Observable, Subject, timer } from "rxjs";
import { AuthSession } from "app/interfaces/authsession.interface";
import { AuthWebService } from "./authweb.service";
import { StorageService } from "./storage.service";
import { Router } from "@angular/router";
import { mapTo, mergeMap, scan, startWith, switchMap, takeWhile, tap } from "rxjs/operators";
import { start } from "repl";

declare var $: any;
@Injectable({
  providedIn: "root",
})
export class SignalrService extends Baseservice {
  constructor(
    private storageService: StorageService,
    http: HttpClient,
    private router: Router,
    authentication: AuthenticationService
  ) {
    super("signalr", http, authentication);
  }

  url: string = environment.authWebApi.url;
  users$ = new BehaviorSubject([]);
  hubConnection: signalR.HubConnection;
  interval;
  ipAddress;
  machinename;
  public connectionId: string;
  sessionId: string;
  public authSession: AuthSession;
  public Isterminated: boolean = false;

  private authSessionSubject = new BehaviorSubject<AuthSession[]>([]);
  private dataStore: { authSessionList: AuthSession[] } = {
    authSessionList: [],
  };
  readonly authSessionList = this.authSessionSubject.asObservable();
  rxjsTimer = timer(1000, 1000);
  reset$ = new Subject();
  sub: Observable<number>;
  public countDown: number = 12;
  interval$ = interval(1000).pipe(mapTo(-1));

  //Start the SignalR Service, Only for Kiosks
  startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.url}/sessionmanager`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.getConnectionId();
        this.terminateSession();
        console.log("Hub Connection Started!");
      })
      .catch((err) => console.log("Error while starting connection: " + err));
  };

  //Receives a list of all the kiosks that are online
  public notifyAdmin = () => {
    this.hubConnection.on("notifyAdmin", (data) => {
      this.dataStore.authSessionList = data;
      this.authSessionSubject.next(
        Object.assign({}, this.dataStore).authSessionList
      );
    });
  };

  //This receives the signal to terminate the session from the Signalr Hub
  public terminateSession = () => {
    this.hubConnection.on("terminateSession", (data) => {
      console.log("About to terminate the session");

      this.reset$ = new Subject();

      // this.sub = this.reset$.pipe(
      //   startWith(0),
      //   switchMap(() => timer(0, 1000)),
      //   takeWhile(() => this.countDown > 0),
      // );

      this.sub = this.reset$.pipe(
        startWith(true),
        switchMap(val => (val ? this.interval$ : empty())),
        scan((acc, curr) => (curr ? curr + acc : acc), this.countDown),
        takeWhile(v => v >= 0)
      )

      this.sub.subscribe((val) => {
        console.log(val);

        if (val === 0) {
          this.stopConnection(data);
          this.logout();

          //Reload the whole application
        }
      });
    });
  };

  //This sends the signal to terminate a session for a particular kiosk
  public stopClientSession(authSession) {
    this.hubConnection
      .invoke("callTerminateSession", authSession)
      .then((data) => {
        console.log("Stop connection", data);
      });
  }

  // public stopAllSignal() {
  //   let sessionId = localStorage.getItem("sessionId");
  //   this.hubConnection.invoke("stopSession", sessionId).then((data) => {
  //     console.log(data);
  //   });
  // }

  //This gets a connection Id from SignalR Hub
  private getConnectionId = () => {
    this.hubConnection.invoke("getconnectionid").then((data) => {
      console.log(data);
      this.connectionId = data;
    });
  };

  //This send a signal to the Hub notifying the Hub, that my session is terminating.
  public stopConnection(authSession) {
    if (this.hubConnection) {
      this.hubConnection.invoke("stopSession", authSession).then((data) => {
        this.hubConnection.stop();
        this.hubConnection = undefined;
        this.logout();
        console.log(data);
      });
    }
  }

  //This is duplicated of log out from Auth Service, to avoid circular dependencies:--> this method will be called upon session termination
  public logout() {
    this.storageService.removeID();
    environment.authWebApi.userData = null;
    let previuosUrl: any = window.location.pathname;
    localStorage.clear();
    localStorage.removeItem("sessionId");
    localStorage.setItem("previousUrl", previuosUrl);
    clearInterval(this.interval);
    this.Isterminated = true;
    this.redirectTo("login");
  }

  //get PC details from the kiosk service
  public getPCDetails() {
    return this.http.get(`${environment.consoleAPIUrl}/getpcdetails`);
  }

  private redirectTo(url: string) {
    this.router.navigate([url]);
  }

  //This sends a heart beat to the server, informing the hub that i am still online
  public userPing(authSession: AuthSession): void {
    if (this.hubConnection) {
      if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
        this.hubConnection
          .invoke("UserRegister", authSession)
          .catch((err) => console.error("userPing error:", err));
      }
    }
  }

  //Sends a heart beat to the server after a specified time has elapsed
  public async SessionManager(authSession: AuthSession) {
    this.startConnection();

    this.interval = setInterval(() => {
      authSession.pcIpAddress = this.ipAddress;
      authSession.dateModified = new Date();
      authSession.sessionEndTime = new Date();
      authSession.connectionId = this.connectionId;
      authSession.pcName = this.machinename;
      this.userPing(authSession);
      this.authSession = authSession;
    }, 10000);
  }

  public end(startTime: Date): number {
    var endTime = new Date();
    var timeDiff = endTime.getTime() - startTime.getTime(); //in ms
    // strip the ms
    timeDiff /= 1000;

    // get seconds
    var seconds = Math.round(timeDiff);
    return seconds;
  }
}
